


export enum CustomReportFieldType {

    Text = "text",
    Number = "number",
    Boolean = "boolean",
    Select = "select",
    SelectJson = "select_json",
    SelectOrCreate = "select_or_create",
    SelectMapping = "select_mapping",
    MultiSelectMapping = "multiselect_mapping",
    MultiSelect = "multiselect",
    ArrayValues = "array_values",
    Array = "array",
    Object = "object",
    Json = "json",
    ColorPicker = "color_picker",
    RegularExpression = "regex",

}